module.exports = __webpack_public_path__ + "static/media/abbe_with_book.f36d2cd5.png";